<div class="load-error" role="alert">
  <div class="load-error__badge" aria-hidden="true"><i class="bx bx-error-circle"></i></div>
  <h3 class="load-error__title">{{ heading() }}</h3>
  <p class="load-error__msg">{{ message() }}</p>
  <button type="button" class="btn btn-primary" (click)="retry.emit()">{{ retryLabel() }}</button>
</div>
